import { useEffect } from "react";
import { Tab, TabContent, Tabs } from "./style";

import {
  listFeedbackDataSelector,
  listRequestLeaveData,
  startDateSelector,
  selectListArriveLateData,
} from "modules/DeclareLeave/redux/selector";
import { useDispatch, useSelector } from "react-redux";

import { Box } from "@mui/material";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import { useLegacyEffect } from "helper/customHook";
import {
  getListArriveLateStart,
  setMonthYearListArriveLate,
} from "modules/DeclareLeave/redux/getListArriveLate";
import {
  getListRequestLeaveStart,
  setMonthYearListRequestLeave,
} from "modules/DeclareLeave/redux/getListRequestLeave";
import moment from "moment";
import "moment/locale/vi"; // Import Vietnamese locale
import { useNavigate, useParams } from "react-router-dom";
import pxToRem from "theme/base/pxToRem";
import { ListArriveLate } from "./ArriveLate";
import { ListLeaveRequest } from "./LeaveRequest";
import { ReactComponent as ArrowDown } from "assets/svg/chevron_down.svg";
import { SCREEN } from "helper/roleChecker/Screens";
import { ListFeedback } from "./ListRespone";
import {
  getListFeedbackStart,
  setMonthYearListFeedback,
} from "modules/DeclareLeave/redux/getListFeedback";
import { declareLeaveURL } from "modules/DeclareLeave/Pages/Main/DeclareLeaveContent/index";
import {
  getConfigMinDateStart,
  updateConfigMinDate,
} from "modules/DeclareLeave/redux/getConfigMinDate";

export const ListLeave = () => {
  const { type } = useParams();

  const navigate = useNavigate();
  const locale = "vi";
  if (moment.locale() !== locale) {
    moment.locale(locale);
  }

  const dispatch = useDispatch();
  const dataArriveLate = useSelector(selectListArriveLateData);
  const dataLeave = useSelector(listRequestLeaveData);
  const dataFeedback = useSelector(listFeedbackDataSelector);
  const startDate = useSelector(startDateSelector);

  const fetchData = (timeValue, tabSelected?: string) => {
    const tab = tabSelected || type;
    const payload = {
      screenCode: SCREEN.IP_016,
      month: timeValue?.format("M"),
      year: timeValue?.format("YYYY"),
      limit: 60,
      offset: 0,
    };
    if (!tab || tab === declareLeaveURL.leave) {
      dispatch(getListRequestLeaveStart(payload));
    } else if (tab === declareLeaveURL.feedback) {
      dispatch(getListFeedbackStart(payload));
    } else {
      dispatch(getListArriveLateStart(payload));
    }
  };

  const handleClickNavigate = (tabContent: string) => {
    // // lấy lại config date để tính toán lại tháng chấm công
    // dispatch(getConfigMinDateStart());

    navigate(
      `/${declareLeaveURL.main}/${declareLeaveURL.orderLeave}/${tabContent}`
    );
    fetchData(startDate, tabContent);
  };

  const handleChangeMonth = (newValue: any) => {
    dispatch(updateConfigMinDate(newValue));
    const timeSelected = {
      month: newValue.month() + 1,
      year: newValue.year(),
    };

    dispatch(setMonthYearListArriveLate(timeSelected));
    dispatch(setMonthYearListFeedback(timeSelected));
    dispatch(setMonthYearListRequestLeave(timeSelected));

    fetchData(newValue);
  };

  useLegacyEffect(() => {
    if (!startDate) return;
    dispatch(
      getListArriveLateStart({
        screenCode: SCREEN.IP_016,
        year: startDate.year(),
        month: startDate.month() + 1,
        limit: 60,
        offset: 0,
      })
    );
    dispatch(
      getListRequestLeaveStart({
        screenCode: SCREEN.IP_016,
        year: startDate.year(),
        month: startDate.month() + 1,
        limit: 60,
        offset: 0,
      })
    );

    dispatch(
      getListFeedbackStart({
        screenCode: SCREEN.IP_016,
        year: startDate.year(),
        month: startDate.month() + 1,
        limit: 60,
        offset: 0,
      })
    );
  }, [startDate]);

  useEffect(() => {
    return () => {
      // lấy lại config date để tính toán lại tháng chấm công
      dispatch(getConfigMinDateStart());
    };
  }, []);

  return (
    <>
      <Box
        display={"flex"}
        justifyContent={"space-between"}
        alignItems={"center"}
        paddingRight={pxToRem(20)}
        flexWrap={"wrap"}
      >
        <Tabs>
          <Tab
            active={!type || type === declareLeaveURL.leave}
            onClick={() => handleClickNavigate(declareLeaveURL.leave)}
            fontWeight={500}
          >
            Đơn xin nghỉ ({dataLeave.length})
          </Tab>
          <Tab
            active={type === declareLeaveURL.lackOfTime}
            onClick={() => handleClickNavigate(declareLeaveURL.lackOfTime)}
            fontWeight={500}
          >
            Đơn xin đi muộn/về sớm ({dataArriveLate.length})
          </Tab>
          <Tab
            active={type === declareLeaveURL.feedback}
            onClick={() => handleClickNavigate(declareLeaveURL.feedback)}
            fontWeight={500}
          >
            Đơn phản hồi ({dataFeedback.length})
          </Tab>
        </Tabs>
        <Box
          display={"flex"}
          alignItems={"center"}
          gap={1}
          sx={(theme) => ({
            [theme.breakpoints.down("md")]: {
              paddingLeft: pxToRem(20),
            },
          })}
        >
          <Box display={"flex"} alignItems={"center"}>
            Tháng
            <LocalizationProvider
              dateAdapter={AdapterMoment}
              adapterLocale={locale}
            >
              <DatePicker
                views={["month", "year"]}
                sx={(theme) => ({
                  fieldset: {
                    border: "none",
                  },
                  ".MuiInputBase-root.MuiOutlinedInput-root": {
                    paddingRight: 0,
                    input: {
                      width: pxToRem(65),
                      textTransform: "capitalize",
                      fontSize: pxToRem(14),
                      paddingLeft: pxToRem(4),
                    },
                  },
                  ".MuiInputAdornment-root.MuiInputAdornment-positionEnd": {
                    opacity: 0,
                    position: "absolute",
                    right: pxToRem(50),
                    button: {
                      width: pxToRem(140),
                      marginRight: `-${pxToRem(75)}`,
                    },
                  },
                })}
                value={startDate}
                format="MM - YYYY"
                slots={{ actionBar: () => null }}
                closeOnSelect={true}
                onChange={handleChangeMonth}
              />
            </LocalizationProvider>
          </Box>
          <ArrowDown />
        </Box>
      </Box>
      <TabContent
        sx={(theme) => ({
          tbody: {
            tr: {
              "&:hover": {
                backgroundColor: `${theme.palette.background.bgBrandPrimary} !important`,
                cursor: "pointer",
              },
            },
            td: {
              fontSize: `12px !important`,
            },
          },
        })}
      >
        {(!type ||
          type === declareLeaveURL.leave ||
          type === declareLeaveURL.earlyRegistration) && <ListLeaveRequest />}
        {type === declareLeaveURL.lackOfTime && <ListArriveLate />}
        {type === declareLeaveURL.feedback && <ListFeedback />}
      </TabContent>
    </>
  );
};
